﻿// Libraries
require('jquery-ui-browserify')
require('bootstrap')
require('bootstrap-maxlength');

import { alertOffline } from './common/dialogs';
import { GetPeriodicAssetPrices } from './common/asset';
import { bindCommon, fixInputs } from './common/bindings';

$(function () {
    GetPeriodicAssetPrices();

    var online = true;
    var close = null;

    setInterval(function () {
        if (!navigator.onLine && online) {
            online = false;
            alertOffline(function (callback) {
                close = callback;
            });
        }

        if (navigator.onLine && !online && typeof (close) == "function") {
            online = true;
            (function (deleteClose) {
                close();
                deleteClose();
            })(function() { close = null });
        }
    }, 500);

    // Set maxlength?
    $("input[maxlength]").maxlength();
    $("textarea[maxlength]").maxlength({
        threshold: 1000
    });
    bindCommon();
    fixInputs();
});